const Tick = require('./tick.core.commonjs')
const Flip = require('././tick.view.flip.commonjs')

Tick.plugin.add(Flip)

export default Tick
